import {Divider, Grid, Tooltip, Typography} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import HelpIcon from "@material-ui/icons/Help";
import React, {useState} from "react";
import Box from "@material-ui/core/Box";
import {useSelector} from "react-redux";
import RiepilogoDialog from "./riepilogo-dialog/RiepilogoDialog";

const ActivationSummaryStep = ({selectedValues}) => {
    const planOptions = useSelector(state => state.ordiniConsipReducer.consipPlans.data)
    const [riepilogoDialogOpen, setRiepilogoDialogOpen] = useState(true)

    const planToDisplay = planOptions.filter(i => i.id === selectedValues.planType)

    const summaryLabels = [
        {
            id: 0,
            text: <Typography variant='body1'>
                Le tue SIM verranno attivate con la seguente configurazione.</Typography>
        },
        {
            id: 1,
            text: <Typography variant='body1' style={{fontWeight: 500}}>
                I valori di default potrebbero comportare costi aggiuntivi.</Typography>
        },
        {
            id: 2,
            text: <Typography variant='body1'>
                E possibile modificare in qualsiasi momento questi valori a seguito dell’attivazione.</Typography>
        },
    ]
    const planDefaults = {
        utenzaPrioritaria: 'No',
        tipologiaDiPiano: planToDisplay[0].shortNomePiano,
        vuoiAttivareRicaricaAutomatica: 'Si',
        tipologiaDiAssenso: 'Tacito assenso',
        vuoiAttivareAutomaticafast: 'No',
        qualeComportamentoVuoiApplicareInCasoDiOverPlafond: '',
        comportamentoSms: 'Pacchetti aggiuntivi con rinnovi infiniti',
        comportamentoMms: 'Pacchetti aggiuntivi con rinnovi infiniti',
        comportamentoVoceInternazionale: 'Pacchetti aggiuntivi con rinnovi infiniti',
        comportamentoServizioDati: 'Pacchetti aggiuntivi con rinnovi infiniti',
        vuoiAttivazioneIlPacchettoGiornalieroPerIlRoamingExtraEuropa: 'Acceso',
        apn: 'Internet',
        ram: 'RAM cliente',
        classeAbilitazioneVoce: '8',
        classeAbilitazioneDati: 'Mondo',
        indirizzoEmailReferente: 'mario.rossi@fastweb.com',
        indirizzoEmailReferenteTooltip: 'Il referente indicato riceverà un messaggio' +
            ' alla sua casella di posta con l’esito dell’attivazione delle SIM.'
    }

    const summaryItem = (label, value, tooltip) => {
        return (
            <Box style={{width:'100%',display:'inline-flex'}}>
                <Grid item xs={12} md={4} style={{paddingRight:'1em'}}>
                    <Typography variant='overline'>{label}</Typography>
                    {tooltip ?
                        <Tooltip title={tooltip} arrow>
                            <IconButton size={"small"}>
                                <HelpIcon fontSize="small" color="primary"/>
                            </IconButton>
                        </Tooltip>
                        : null}
                </Grid>
                <Grid item xs={12} md={5}>
                    <Typography variant='subtitle2'>{value}</Typography>
                </Grid>
            </Box>
        )
    }
    return (
        <>
            <Grid container>
                {summaryLabels.map((item) => (
                    <Grid item key={item.id} xs={12}>
                        {item.text}
                    </Grid>
                ))}
            </Grid>
            <Divider/>
            {summaryItem('utenza prioritaria', planDefaults.utenzaPrioritaria)}
            <Divider/>
            {summaryItem('Tipologia di piano', planDefaults.tipologiaDiPiano)}
            <Divider/>
            {summaryItem('Vuoi attivare Ricarica Automatica?', planDefaults.vuoiAttivareRicaricaAutomatica)}
            {summaryItem('Tipologia di assenso', planDefaults.tipologiaDiAssenso)}
            <Divider/>
            {summaryItem('Vuoi attivare AutomaticaFast', planDefaults.vuoiAttivareAutomaticafast)}
            <Divider/>
            {summaryItem('Quale comportamento vuoi applicare in caso di Over Plafond?', planDefaults.qualeComportamentoVuoiApplicareInCasoDiOverPlafond)}
            {summaryItem('Comportamento SMS', planDefaults.comportamentoSms)}
            {summaryItem('Comportamento MMS', planDefaults.comportamentoMms)}
            {summaryItem('Comportamento Voce Internazionale', planDefaults.comportamentoVoceInternazionale)}
            {summaryItem('Comportamento Servizio Dati', planDefaults.comportamentoServizioDati)}
            <Divider/>
            {summaryItem('Vuoi attivazione il pacchetto giornaliero per il roaming extra Europa?',
                planDefaults.vuoiAttivazioneIlPacchettoGiornalieroPerIlRoamingExtraEuropa)}
            <Divider/>
            <Typography variant='h6'>Configurazione tecnica SIM</Typography>
            {summaryItem('APN', planDefaults.apn)}
            {summaryItem('RAM', planDefaults.ram)}
            {summaryItem('CLASSE ABILITAZIONE VOCE', planDefaults.classeAbilitazioneVoce)}
            {summaryItem('CLASSE ABILITAZIONE dati', planDefaults.classeAbilitazioneDati)}
            <Divider/>
            {summaryItem('INDIRIZZO E-MAIL REFERENTE',
                planDefaults.indirizzoEmailReferente,
                planDefaults.indirizzoEmailReferenteTooltip)}
            {riepilogoDialogOpen ? <RiepilogoDialog open={riepilogoDialogOpen}
                                                    handleDialogClose={() => setRiepilogoDialogOpen(false)}/> : null}
        </>
    )
}

export default ActivationSummaryStep;


